<template>
  <div class="p-0 col-12 animated fadeIn">
    <div v-if="inbound" class="card">
      <div class="card-body">
        <form class="form-horizontal">
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Arrival Date</label>
            <div class="col-6 col-md-8 col-lg-9">
              <kendo-datepicker v-model="inbound.arrival_date" class="form-control"></kendo-datepicker>
              <!-- <input type="text" placeholder="Inbound Document Number" class="form-control" v-model="inbound.arrival_date"/> -->
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Document Number</label>
            <div class="col-6 col-md-8 col-lg-9">
              <input type="text" placeholder="Inbound Document Number" class="form-control" v-model="inbound.document_number"/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Supplier</label>
            <div class="col-6 col-md-8 col-lg-9">
              <vue-select :placeholder="'Select Supplier'" :filterable="false" 
                  :options="suppliers" @search="searchSupplier" :multiple="false" 
                  :ref="'select-supplier'" v-model="inbound.supplier">
                <template slot="no-options">
                  type to search supplier
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name.toUpperCase() }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name.toUpperCase() }}
                  </div>
                </template>
              </vue-select>
              <!-- <input type="text" placeholder="Inbound Document Number" class="form-control" v-model="inbound.supplier"/> -->
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Product</label>
            <div class="col-6 col-md-8 col-lg-9">
              <vue-select :placeholder="'Select Product'" :filterable="false" 
                  :options="products" @search="searchProduct" :multiple="false" 
                  :ref="'select-product'" v-model="inbound.product">
                <template slot="no-options">
                  type to search product
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name.toUpperCase() }} - {{ option.code.toUpperCase() }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name.toUpperCase() }} - {{ option.code.toUpperCase() }}
                  </div>
                </template>
              </vue-select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Racks</label>
            <div class="col-6 col-md-8 col-lg-9">
              <input type="text" placeholder="Inbound Document Number" class="form-control" v-model="inbound.racks"/>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-primary" @click="submit">UPDATE</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueSelect from 'vue-select'

export default {
  data () {
    return {
      button: {
        name: 'Add Inbound',
        icon: 'fa fa-plus',
        url: '/inventory/inbound/add'
      },
      inbound: null,
      products: [],
      suppliers: [],
      verification: {
        'document': true,
        'date': true,
        'product': true,
        'supplier': true
      }
    }
  },
  components: {
    VueSelect
  },
  created () {
    // change button
    this.$parent.button = this.button
    window.kendo.culture('id-ID')
    // get data
    this.getInbound()
  },
  methods: {
    getInbound () {
      var uid = this.$route.params.uid
      var vm = this
      vm.axios.get('api/inventory/inbound/' + uid + '/')
        .then(
          (response) => {
            console.log(response)
            vm.inbound = response.data
            vm.products.push(response.data.product)
            vm.suppliers.push(response.data.supplier)
          }
        )
        .catch(
          (error) => {
            console.log(error)
            if (error.response.status === 404) {
              vm.$router.push('Four Oh Four')
            }
          }
        )
    },
    searchProduct (search, loading) {
      var vm = this
      loading(true)
      vm.axios.get('api/sales/products/search/' + encodeURIComponent(search) + '/?limit=10&offset=0')
        .then(
          (response) => {
            vm.products = response.data
            loading(false)
          }
        )
    },
    searchSupplier (search, loading) {
      var vm = this
      loading(true)
      vm.axios.get('api/inventory/vendor/?search=' + encodeURIComponent(search))
        .then(
          (response) => {
            vm.suppliers = response.data
            loading(false)
          }
        )
    },
    submit () {
      var vm = this
      console.log(vm.inbound)

      var data = new URLSearchParams()
      data.append('document_number', vm.inbound.document_number)
      data.append('arrival_date', moment(vm.inbound.arrival_date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
      data.append('product', vm.inbound.product.code)
      data.append('supplier', vm.inbound.supplier.uid)
      data.append('racks', vm.inbound.racks)
      // post data
      vm.axios.put('api/inventory/inbound/' + vm.inbound.uid + '/', data)
        .then(
          (response) => {
            console.log(response)
            vm.$parent.showNotification('Inbound data updated', 'success')
            vm.$router.push('/inventory/inbound')
          }
        )
        .catch(
          (error) => {
            console.log(error)
            vm.$parent.showNotification('Oops! Unable to submit data at this moment. Please try again later!', 'danger')
          }
        )
    },
    verify () {
      return true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/inbound/EditInbound.vue